// namespace
window.Components = window.Components || {};

(function($) {

  'use strict';

  function videoPlayer() {

    var self = this,
        youtubeObj = false,
        $cache = {};

    /**
     * Hide Cover
     */
    function showCover(callback) {
      var tl = new TimelineMax({paused: true, onStart: function() {
        $cache.overlayWrapper.show();
      }, onComplete: function() {
        if(callback) callback();
      }});

      tl.to($cache.overlayWrapper, 0.7, {opacity: 1, ease: Quad.easeOut}, 0);

      tl.play();
    }

    /**
     * Hide Cover
     */
    function hideCover(callback) {
      var tl = new TimelineMax({paused: true, onStart: function() {
        if(callback) callback();
      }, onComplete: function() {
        $cache.overlayWrapper.hide();
      }});

      tl.to($cache.overlayWrapper, 0.6, {opacity: 0, force3D: true, ease: Expo.easeOut}, 0);

      tl.play();
    }

    /**
     * Init Video Player
     */
    function initVideoPlayer() {
      youtubeObj = $cache.youtube.data('comp');

      registerEvents();
    }
    
    /**
     * Init Cache
     */
    function initCache(target) {
      $cache.main = target;
      $cache.youtube = $cache.main.find('.video-component');

      $cache.overlayWrapper = $cache.main.find('.overlay-wrapper');
      $cache.overlay = $cache.overlayWrapper.find('.overlay');
      $cache.play = $cache.overlayWrapper.find('.play');
    }

    /**
     * Register Events
     */
    function registerEvents() {
      $cache.play.on('click', function(){
        hideCover(youtubeObj.playVideo);
      });

      $cache.play.on('keydown', function(event){
        if ( event.which == 13 || event.which == 32) {
          event.preventDefault();
          $cache.play.trigger('click');
        }
      });

      $cache.youtube.on('ended', function(){
        showCover();
      });
    }


    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(target) {      
      initCache(target);

      $cache.youtube.on('ready', initVideoPlayer);
    };

    self.initialize.apply(self, arguments);
    return self;
  }
  
  window.Components.videoPlayer = videoPlayer;
  
}(jQuery));
